import React, { useEffect, useMemo, useState } from "react";
import { ArrowLeft, Plus, Search } from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";
import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import { TableCell, TableRow, TableBody, Typography } from "@mui/material";
import { MdOutlineDelete } from "react-icons/md";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Product from "../../../actions/product";
import Order from "../../../actions/order";
import UpdateOrderProductForm from "../../../components/forms/orderProduct";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import CustomerDetails from "./orderProfiel";
import { Box } from "@mui/material";
import { formatNumber, updatePrices } from "../../../utils/utils";
import CustomerOrder from "./CustomerOrders";
import { UpdateOrderManagement } from "./updateOrderManagement";
import Norecords from "../../../components/customHelpers/Norecords";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoComponent from "../../../components/InfoComponent";

const headCells = [
  { id: "name", label: "Product Name" },
  { id: "store", label: "Store" },
  { id: "sku", label: "Sku" },
  { id: "quantity", label: "Quantity" },
  { id: "price", label: "Price" },
  { id: "disount", label: "Discount" },
  { id: "totalPrice", label: "Total Price" },
  { id: "updatedAt", label: "UpdatedAt" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const SelectedProductDetails = ({ product }) => {
  if (!product) return null;

  return (
    <div className="bg-gradient-to-r from-green-50 to-teal-50 border border-green-200 rounded-md p-1.5 shadow-sm mb-2">
      <h3 className="text-xs font-semibold text-green-900 mb-1 border-b border-green-200 pb-0.5">
        Selected Product
      </h3>
      <div className="flex flex-wrap gap-2">
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium text-gray-600 min-w-[35px]">
            Name:
          </span>
          <span className="text-xs text-gray-900 font-medium">
            {product.product?.name}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium text-gray-600 min-w-[35px]">
            SKU:
          </span>
          <span className="text-xs text-gray-900">{product.product?.sku}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium text-gray-600 min-w-[35px]">
            Stock:
          </span>
          <span className="text-xs text-gray-900">{product.quantity}</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium text-gray-600 min-w-[35px]">
            Store:
          </span>
          <span className="text-xs text-gray-900">
            {product.store.locationName}
          </span>
        </div>
      </div>
    </div>
  );
};

const ProductDetailPage = () => {
  const [orderStatus, setOrderStatus] = useState("");
  const history = useHistory();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewOrder, deleteOrder, updateOrderStatus } = Order();
  const { viewAllProductsLists, updateProductList } = Product();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productLists, setProductLists] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
    submitting: false,
  });
  const { loading, reload, submitting } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];

  const [newlyCreatedItems, setNewlyCreatedItems] = useState([]);
  const [updatedItems, setUpdatedItems] = useState([]);

  useEffect(() => {
    getAllProducts();
  }, []);

  useEffect(() => {
    getOrderData();
  }, [value]);

  useEffect(() => {
    if (productData) {
      setOrderStatus(productData.status);
      setRemark(productData.remark);
    }
  }, [productData]);

  const getOrderData = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.orders.orderProducts);
        setProductData(data.orders);
        setPaid(data.orders.paid);
        setRemark(productData?.remark);
      }
    });
  };

  const getOrderDataTemp = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.orders.orderProducts);
        setProductData(data.orders);
        setPaid(data.orders.paid);
      }
    });
  };

  const handleSearchInputChange = (event) => {
    let input = event.target.value;
    setInputValue(input);
    if (event) {
      const filtered = products.filter(
        (data) =>
          data.product?.name.toLowerCase().includes(input.toLowerCase()) ||
          data.product?.sku.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  };
  const handleProductInputFocus = () => {
    setFilteredProducts(products.filter((option) => option.quantity > 0));
  };

  const [paid, setPaid] = useState("");
  const [unpaid, setUnpaid] = useState("");
  const [productId, setProdcutId] = useState();
  const [price, setPrice] = useState("");
  const [productName, setProductName] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [store, setStore] = useState();
  const [sku, setSku] = useState();
  const [inputValue, setInputValue] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [discountValue, setDiscountValue] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [warning, setWarning] = useState("");
  const [isPercentDiscount, setIsPercentDiscount] = useState(false);
  const [qt, setQt] = useState(0);
  const [productQuantity, setProductQuantity] = useState(0);

  const handleChangeQt = (e) => {
    const value = Number(e.target.value);
    if (productQuantity && value > productQuantity) {
      setQuantityError("Quantity exceeds available stock");
    } else {
      setQuantityError("");
    }
    setQt(e.target.value);
  };

  const onChangeProductList = (event) => {
    if (event) {
      setProductName(event.product.name);
      setProdcutId(event.id);
      setProductQuantity(event.quantity);
      setPrice(event.price);
      setStore(event.store?.locationName);
      setSku(event.product.sku);
    }
    setSelectedProduct(event);
    setFilteredProducts([]);
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const {
    filterOrdersByProductId,
    orders,
    groupByStatusAndSumQuantities,
    addPendingOrderLocally,
    removeQuantityLocally,
  } = UpdateOrderManagement();

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productLists, headCells, filterFn);

  const onDelete = (deleted, quantity) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteOrder(deleted.id).then((data) => {
      if (data.err) {
        if (data.err !== "order is not found!") {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        }
        if (data.err === "order is not found!") {
          setProductLists(
            produce(productLists, (draft) => {
              const index = deleted.id
                ? draft.findIndex((item) => item.id === deleted.id)
                : draft.findIndex(
                    (item) =>
                      item.product === deleted.product &&
                      Number(item.price.trim()) ===
                        Number(deleted.price.trim()) &&
                      Number(item.discount) === Number(deleted.discount)
                  );
              if (index !== -1) {
                draft.splice(index, 1);
              }
            })
          );

          const updatedProducts = products.map((product) =>
            product.id === deleted.product
              ? {
                  ...product,
                  quantity: Number(product.quantity) + Number(quantity),
                }
              : product
          );
          setProducts(updatedProducts);
          setNewlyCreatedItems((prev) =>
            prev.filter(
              (item) =>
                !(
                  item.product === deleted.product &&
                  Number(item.price.trim()) === Number(deleted.price.trim()) &&
                  Number(item.discount) === Number(deleted.discount)
                )
            )
          );
          setUpdatedItems((prev) =>
            prev.filter(
              (item) =>
                !(
                  item.product === deleted.product &&
                  Number(item.price.trim()) === Number(deleted.price.trim()) &&
                  Number(item.discount) === Number(deleted.discount)
                )
            )
          );
        }
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        getAllProducts();
        getOrderDataTemp();
      }
      removeQuantityLocally(deleted.sku, quantity, productData?.id);
    });
  };

  const [products, setProducts] = useState([]);
  const { updateOrder } = Order();

  const getAllProducts = () => {
    viewAllProductsLists().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setProducts(updatePrices(data.product));
      }
    });
  };

  const updateProductPrice = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    updateProductList({ price: price }, selectedProduct.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: "Product Price successfully updated",
          type: "success",
        });
        updatePrice(selectedProduct.id, price);
      }
    });
  };

  const updatePrice = (id, newPrice) => {
    setProducts((products) =>
      products.map((item) =>
        item.id === id ? { ...item, price: newPrice } : item
      )
    );
  };

  const saveData = () => {
    setClicked(true);
    if (selectedProduct.price !== price) {
      setConfirmDialog({
        isOpen: true,
        title: "Are you sure to update the inventory price?",
        onConfirm: () => {
          updateProductPrice();
        },
      });
    }
    const existingProductIndex = productLists.findIndex(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discountValue)
    );
    const existingItem = productLists.find(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discountValue)
    );
    const quantityToAdd = Number(qt);

    if (existingItem && existingItem.id) {
      const updatedData = productLists.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: Number(item.quantity) + quantityToAdd,
              totalPrice:
                discount > 0
                  ? (item.price - item.discount) *
                    (Number(item.quantity) + quantityToAdd)
                  : (Number(item.quantity) + quantityToAdd) * item.price,
            }
          : item
      );
      setProductLists(updatedData);
      setUpdatedItems((prev) => {
        const existingUpdatedIndex = prev.findIndex(
          (item) =>
            item.product === productId &&
            Number(item.price.trim()) === Number(price.trim()) &&
            Number(item.discount) === Number(discount)
        );
        if (existingUpdatedIndex !== -1) {
          return prev.map((item, index) =>
            index === existingUpdatedIndex
              ? {
                  ...item,
                  quantityToAdd: Number(item.quantityToAdd) + quantityToAdd,
                }
              : item
          );
        } else {
          return [
            ...prev,
            {
              product: productId,
              sku: sku,
              price: price,
              discount: discount,
              quantityToAdd: quantityToAdd,
              store: store,
            },
          ];
        }
      });
    } else {
      const existingNewlyCreatedIndex = newlyCreatedItems.findIndex(
        (item) =>
          item.product === productId &&
          Number(item.price.trim()) === Number(price.trim()) &&
          Number(item.discount) === Number(discount)
      );
      let totalPrice = quantityToAdd * price;
      if (discount > 0) {
        totalPrice = calculateItemTotal.toFixed(2);
      }
      const newItem = {
        product: productId,
        discount: discountValue,
        price: price,
        store: store,
        sku: sku,
        totalPrice: totalPrice,
        quantity: qt,
        productName: productName,
      };

      if (existingNewlyCreatedIndex !== -1) {
        setNewlyCreatedItems((prev) =>
          prev.map((item, index) =>
            index === existingNewlyCreatedIndex
              ? {
                  ...item,
                  quantity: Number(item.quantity) + quantityToAdd,
                  totalPrice:
                    discount > 0
                      ? (item.price - item.discount) *
                        (Number(item.quantity) + quantityToAdd)
                      : (Number(item.quantity) + quantityToAdd) * item.price,
                }
              : item
          )
        );
        if (existingProductIndex !== -1) {
          setProductLists((prev) =>
            prev.map((item, index) =>
              index === existingProductIndex
                ? {
                    ...item,
                    quantity: Number(item.quantity) + quantityToAdd,
                    totalPrice:
                      discount > 0
                        ? (item.price - item.discount) *
                          (Number(item.quantity) + quantityToAdd)
                        : (Number(item.quantity) + quantityToAdd) * item.price,
                  }
                : item
            )
          );
        } else {
          setProductLists((prev) => [...prev, newItem]);
        }
      } else {
        setProductLists((prev) => [...prev, newItem]);
        setNewlyCreatedItems((prev) => [...prev, newItem]);
      }
    }

    const updatedProducts = products.map((product) =>
      product.id === productId
        ? { ...product, quantity: product.quantity - quantityToAdd }
        : product
    );
    setProducts(updatedProducts);
    addPendingOrderLocally({
      sku,
      quantity: quantityToAdd,
      status: orderStatus,
      orderId: productData?.id,
    });
    setPrice("");
    setQt(0);
    setProdcutId(null);
    setProductName(null);
    setSelectedProduct(null);
    setInputValue("");
    setDiscount(0);
    setFilteredProducts([]);
  };

  const calculateItemTotal = useMemo(() => {
    if (isPercentDiscount) {
      const totalPriceWithoutDiscount = price * qt;
      const discountAmount = (price * discount * qt) / 100;
      const netDiscount = (price * discount) / 100;
      setDiscountValue(netDiscount);
      return totalPriceWithoutDiscount - discountAmount;
    } else {
      setDiscountValue(discount);
      return (price - discount) * qt;
    }
  }, [isPercentDiscount, discount, price, qt]);

  const handlePaidChange = (event) => {
    const newPaid = parseFloat(event.target.value) || 0;
    if (/^\d*\.?\d*$/.test(newPaid)) {
      const totalPrice = calculateTotalPrice();
      const remaining = totalPrice - newPaid;
      setUnpaid(remaining);
    }
    setPaid(event.target.value);
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (productLists.length > 0) {
      productLists.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice) || 0;
      });
    }
    return totalPrice.toFixed(2);
  };

  const handleSubmit = () => {
    let orderData = {
      items: productLists,
      remark: remark,
      paid: paid,
      updatedItems: updatedItems.map((item) => ({
        sku: item.sku,
        store: item.store,
        quantityToAdd: item.quantityToAdd,
      })),
      newlyCreatedItems: newlyCreatedItems.map((item) => ({
        sku: item.sku,
        quantityToAdd: item.quantity,
        store: item.store,
      })),
    };
    setValues({ ...values, submitting: true });
    updateOrder(orderData, value).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        history.push(`/print/${value}`);
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: "Order successfully updated",
          type: "success",
        });
        setNewlyCreatedItems([]);
        setUpdatedItems([]);
      }
    });
  };
  const handleCache = () => {
    let item;
    const existingProductIndex = productLists.findIndex(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    const existingItem = productLists.find(
      (item) =>
        item.product === productId &&
        Number(item.price.trim()) === Number(price.trim()) &&
        Number(item.discount) === Number(discount)
    );
    const quantityToAdd = Number(qt);

    if (existingItem && existingItem.id) {
      const updatedData = productLists.map((item, index) =>
        index === existingProductIndex
          ? {
              ...item,
              quantity: Number(item.quantity) + quantityToAdd,
              totalPrice:
                discount > 0
                  ? calculateItemTotal.toFixed(2) *
                    (Number(item.quantity) + quantityToAdd)
                  : (Number(item.quantity) + quantityToAdd) * item.price,
            }
          : item
      );
      item = updatedData;
      setUpdatedItems((prev) => {
        const existingUpdatedIndex = prev.findIndex(
          (item) =>
            item.product === productId &&
            Number(item.price.trim()) === Number(price.trim()) &&
            Number(item.discount) === Number(discount)
        );
        if (existingUpdatedIndex !== -1) {
          return prev.map((item, index) =>
            index === existingUpdatedIndex
              ? {
                  ...item,
                  quantityToAdd: Number(item.quantityToAdd) + quantityToAdd,
                }
              : item
          );
        } else {
          return [
            ...prev,
            {
              product: productId,
              sku: sku,
              price: price,
              discount: discount,
              quantityToAdd: quantityToAdd,
            },
          ];
        }
      });
    } else {
      const existingNewlyCreatedIndex = newlyCreatedItems.findIndex(
        (item) =>
          item.product === productId &&
          Number(item.price.trim()) === Number(price.trim()) &&
          Number(item.discount) === Number(discount)
      );
      let totalPrice = quantityToAdd * price;
      if (discount > 0) {
        totalPrice = calculateItemTotal.toFixed(2) * quantityToAdd;
      }
      const newItem = {
        product: productId,
        price: price,
        store: store,
        sku: sku,
        totalPrice: totalPrice,
        quantity: qt,
        productName: productName,
      };

      if (existingNewlyCreatedIndex !== -1) {
        setNewlyCreatedItems((prev) =>
          prev.map((item, index) =>
            index === existingNewlyCreatedIndex
              ? {
                  ...item,
                  quantity: Number(item.quantity) + quantityToAdd,
                  totalPrice:
                    discount > 0
                      ? calculateItemTotal.toFixed(2) *
                        (Number(item.quantity) + quantityToAdd)
                      : (Number(item.quantity) + quantityToAdd) * item.price,
                }
              : item
          )
        );
        if (existingProductIndex !== -1) {
          setProductLists((prev) =>
            prev.map((item, index) =>
              index === existingProductIndex
                ? {
                    ...item,
                    quantity: Number(item.quantity) + quantityToAdd,
                    totalPrice:
                      discount > 0
                        ? calculateItemTotal.toFixed(2) *
                          (Number(item.quantity) + quantityToAdd)
                        : (Number(item.quantity) + quantityToAdd) * item.price,
                  }
                : item
            )
          );
        } else {
          setProductLists((prev) => [...prev, newItem]);
        }
      } else {
        item = [...productLists, newItem];
        setNewlyCreatedItems((prev) => [...prev, newItem]);
        setProductLists(item);
      }
    }

    const updatedProducts = products.map((product) =>
      product.id === productId
        ? { ...product, quantity: product.quantity - quantityToAdd }
        : product
    );
    setProducts(updatedProducts);
    let orderData = {
      items: item || productLists,
      remark: remark,
      paid: paid,
      updatedItems: updatedItems.map((item) => ({
        sku: item.sku,
        quantityToAdd: item.quantityToAdd,
      })),
      newlyCreatedItems: newlyCreatedItems.map((item) => ({
        sku: item.sku,
        quantityToAdd: item.quantity,
      })),
    };
    setValues({ ...values, submitting: true });
    updateOrder(orderData, value).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        setValues({ ...values, submitting: false });
        history.push(`/print/${value}`);
        let message = "Order successfully updated";
        NotifyMessage({
          message: message,
          type: "success",
        });
        setNewlyCreatedItems([]);
        setUpdatedItems([]);
      }
    });
  };

  const [remark, setRemark] = useState("");

  const handleChange = (event) => {
    setRemark(event.target.value);
  };

  const handleDiscountChange = (e) => {
    const newDiscount = Number(e.target.value);
    setDiscount(e.target.value);
    setWarning("");
    if (isPercentDiscount) {
      if (newDiscount > 100) {
        setWarning("Discount percentage cannot exceed 100%.");
      }
    } else if (newDiscount > price) {
      setWarning("Discount cannot exceed item price.");
    }

    if (isPercentDiscount) {
      const discountAmount = (price * newDiscount) / 100;
      setDiscountValue(discountAmount);
    } else {
      setDiscountValue(newDiscount);
    }
  };

  const filteredResults = filterOrdersByProductId(sku);
  const summedResults = groupByStatusAndSumQuantities(filteredResults);

  return (
    <Layout>
      <div className="card" style={{ marginBottom: 0, borderRadius: 0 }}>
        <Box>
          <Typography variant="h6">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/orders");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>Edit Order Detail</span>
          </Typography>
        </Box>
        <InfoComponent pageKey="editOrderDetail" />
      </div>

      {loading ? (
        <Loading />
      ) : (
        <>
          {productData && (
            <div className="bg-white border border-gray-200 rounded-md p-2 mb-2 shadow-sm">
              <h2 className="text-sm font-semibold text-blue-900 mb-1.5">
                Customer Information
              </h2>
              <div className="flex flex-col [@media(min-width:1180px)]:flex-row  gap-2">
                <div className="">
                  <CustomerDetails
                    title="Customer"
                    change="true"
                    id={value}
                    product={productData}
                    getOrderData={getOrderData}
                  />
                </div>
                <div className="[@media(min-width:1180px)]:w-[65%] flex flex-col gap-1.5">
                  <CustomerOrder id={productData?.customer?.id} />
                </div>
              </div>
            </div>
          )}

          <div className="bg-white border border-gray-200 rounded-md shadow-sm p-3 mb-2">
            <h2 className="text-sm font-semibold text-blue-900 mb-2 border-b border-gray-200 pb-2">
              Order Items
            </h2>
            <div className="scrollable-table-container overflow-auto">
              <div className="scrollable-table min-w-[1000px] whitespace-nowrap">
                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().length > 0 ? (
                      recordsAfterPagingAndSorting().map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.productName}</TableCell>
                          <TableCell>{item.store}</TableCell>
                          <TableCell>{item.sku}</TableCell>
                          <TableCell>{item.quantity}</TableCell>
                          <TableCell>{item.price}</TableCell>
                          <TableCell>
                            {item.discount ? item.discount : 0}
                          </TableCell>
                          <TableCell>{formatNumber(item.totalPrice)}</TableCell>
                          <TableCell>
                            {item.updatedAt
                              ? new Date(item.updatedAt).toLocaleString()
                              : new Date().toLocaleString()}
                          </TableCell>
                          <TableCell>
                            <Controls.ActionButton
                              color="secondary"
                              title="Delete"
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title:
                                    "Are you sure to delete this Order Product?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    onDelete(
                                      item.id ? item : item,
                                      item.quantity
                                    );
                                  },
                                });
                              }}
                            >
                              <MdOutlineDelete fontSize="medium" />
                            </Controls.ActionButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <Norecords col={6} />
                    )}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
            <TblPagination />
          </div>

          {products.length > 0 && (
            <div className="bg-white border border-gray-200 rounded-md shadow-sm p-3 mb-2">
              <div className="flex justify-between items-center mb-2 border-b border-gray-200 pb-2">
                <h2 className="text-sm font-semibold text-blue-900 font-text-secondary-main">
                  Order Details
                </h2>

                <div className="flex items-center">
                  <label className="mr-2 whitespace-nowrap text-sm font-medium font-text-secondary-main">
                    Order Status
                  </label>
                  <input
                    type="text"
                    value={orderStatus}
                    disabled
                    className="w-full rounded-md border border-gray-300 bg-gray-100 p-1.5 text-xs text-gray-600"
                  />
                </div>
              </div>

              <div className="flex flex-col [@media(min-width:1180px)]:flex-row gap-3">
                <div className="[@media(min-width:1180px)]:w-1/4">
                  <h3 className="text-sm font-semibold font-text-secondary-main mb-2">
                    Select Product
                  </h3>
                  <div
                    className="search-header-container"
                    style={{ marginBottom: 0 }}
                  >
                    <div className="search-header-flex">
                      <div className="search-container">
                        <Search className="search_icon" />
                        <input
                          type="text"
                          placeholder="Search products..."
                          value={inputValue}
                          onChange={handleSearchInputChange}
                          onFocus={handleProductInputFocus}
                          className="search-input"
                          style={{ width: "100%" }}
                        />
                        {filteredProducts.length > 0 && (
                          <ul className="absolute z-20 mt-1 max-h-40 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 border border-gray-200">
                            {(filteredProducts.length === 0
                              ? products.filter((option) => option.quantity > 0)
                              : filteredProducts.filter(
                                  (option) => option.quantity > 0
                                )
                            ).map((option) => (
                              <li
                                key={option.id}
                                className="cursor-pointer select-none py-1.5 px-2 hover:bg-blue-50 hover:text-blue-700 text-gray-900 border-b border-gray-100 last:border-b-0"
                                onClick={() => onChangeProductList(option)}
                              >
                                <div className="font-medium text-xs">
                                  {`${option.product?.name} - ${
                                    option.product?.sku
                                  } - ${option.quantity} - ${
                                    option.store?.locationName
                                      ? option.store?.locationName
                                      : ""
                                  }`}
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="[@media(min-width:1180px)]:w-1/2">
                  <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
                    <h3 className="text-sm font-semibold font-text-secondary-main mb-2">
                      Product Details
                    </h3>

                    <SelectedProductDetails product={selectedProduct} />

                    <div className="mb-2">
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Order Status
                      </label>
                      <div className="bg-white rounded-md border border-gray-200 p-1.5">
                        {selectedProduct && summedResults.length > 0 ? (
                          summedResults.map((result, index) => (
                            <div
                              key={index}
                              className="flex justify-start items-center text-xs gap-x-10"
                            >
                              <span className="text-gray-600">
                                {result.status}:
                              </span>
                              <span className="font-medium text-gray-900">
                                {result.totalQuantity}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div className="text-xs text-gray-500">
                            <div className="flex justify-start items-center gap-x-10">
                              <span>Ordered:</span>
                              <span>0</span>
                            </div>
                            <div className="flex justify-start items-center gap-x-10">
                              <span>Pending:</span>
                              <span>0</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mt-2 grid grid-cols-2 md:grid-cols-4 gap-2">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Quantity
                        </label>
                        <input
                          type="number"
                          value={qt}
                          onChange={handleChangeQt}
                          disabled={!selectedProduct}
                          className={`w-24 border ${
                            quantityError ? "border-red-500" : "border-gray-300"
                          } rounded-md p-1.5 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:text-gray-500`}
                          placeholder="0"
                        />
                        {quantityError && (
                          <p className="text-red-500 text-xs mt-0.5">
                            {quantityError}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Unit Price
                        </label>
                        <input
                          type="number"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                          disabled={!selectedProduct}
                          className="w-24 border border-gray-300 rounded-md p-1.5 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                          placeholder="0.00"
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Discount
                        </label>
                        <input
                          type="number"
                          value={discount}
                          onChange={handleDiscountChange}
                          disabled={!selectedProduct}
                          className={`w-24 border ${
                            warning ? "border-red-500" : "border-gray-300"
                          } rounded-md p-1.5 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:text-gray-500`}
                          placeholder="0"
                        />
                        {warning && (
                          <p className="text-red-500 text-xs mt-0.5">
                            {warning}
                          </p>
                        )}
                        <label className="flex items-center gap-1 mt-1">
                          <input
                            type="checkbox"
                            checked={isPercentDiscount}
                            onChange={(e) =>
                              setIsPercentDiscount(e.target.checked)
                            }
                            disabled={!selectedProduct}
                            className="h-3 w-3 text-blue-600 focus:ring-blue-500 border-gray-300 rounded disabled:opacity-50"
                          />
                          <span className="text-xs text-gray-700">Percent</span>
                        </label>
                      </div>

                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Total Price
                        </label>
                        <input
                          type="text"
                          value={
                            qt > 0 && price && selectedProduct
                              ? discount > 0
                                ? calculateItemTotal.toFixed(2)
                                : (price * qt).toFixed(2)
                              : "0.00"
                          }
                          disabled
                          className="w-24 border border-gray-300 rounded-md p-1.5 text-xs bg-gray-100 text-gray-600"
                        />
                      </div>
                    </div>

                    <div className="mt-2">
                      <Controls.Button
                        text="Add Item"
                        size="small"
                        variant="contained"
                        startIcon={<Plus className="w-3 h-3" />}
                        disabled={!selectedProduct || qt <= 0 || quantityError}
                        className={`w-24 bg-green-600 hover:bg-green-700 text-white px-2 py-1.5 rounded-md flex items-center justify-center gap-1 text-xs font-medium disabled:bg-gray-400 disabled:cursor-not-allowed`}
                        onClick={saveData}
                      />
                    </div>
                  </div>
                </div>

                <div className="[@media(min-width:1180px)]:w-1/4 space-y-2">
                  <h3 className="text-sm font-semibold font-text-secondary-main mb-2">
                    Order Notes & Payment
                  </h3>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Order Notes
                    </label>
                    <textarea
                      rows="3"
                      placeholder="Remark"
                      value={remark}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md p-1.5 text-xs resize-vertical focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Total Price
                    </label>
                    <div className="text-sm font-bold text-gray-900">
                      {formatNumber(calculateTotalPrice())}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Paid Amount
                    </label>
                    <input
                      type="number"
                      value={paid}
                      onChange={handlePaidChange}
                      className="w-full border border-gray-300 rounded-md p-1.5 text-xs focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="0.00"
                      step="1"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                      Balance
                    </label>
                    <input
                      type="text"
                      value={formatNumber(
                        (calculateTotalPrice() - paid).toFixed(2)
                      )}
                      disabled
                      className="w-full border border-gray-300 rounded-md p-1.5 text-xs bg-gray-100 text-gray-600"
                    />
                  </div>

                  <div className="flex flex-row items-start gap-2 pt-2">
                    <Controls.Button
                      disabled={values.submitting || products.length === 0}
                      text="Cancel"
                      variant="contained"
                      className="w-full bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                      onClick={() => {
                        history.push(`/print/${value}`);
                      }}
                    />
                    {productId || selectedProduct ? (
                      <Controls.Button
                        disabled={values.submitting || products.length === 0}
                        text={
                          values.submitting ? "Updating..." : "Update Order"
                        }
                        variant="contained"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                        onClick={() => {
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to Add this Order?",
                            subTitle: "There is A Product that is not added",
                            onConfirm: () => {
                              handleCache();
                            },
                            onCancel: () => {
                              handleSubmit();
                            },
                          });
                        }}
                      />
                    ) : (
                      <Controls.Button
                        disabled={values.submitting || products.length === 0}
                        text={
                          values.submitting ? "Updating..." : "Update Order"
                        }
                        variant="contained"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                        onClick={handleSubmit}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <Popup
        title="Order Product Update Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <UpdateOrderProductForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          getOrderData={getOrderData}
          setProducts={setProductLists}
          edite={edite}
        />
      </Popup>
    </Layout>
  );
};

export default ProductDetailPage;
